import mapData from "lib/stores/mapData";
import context from "lib/stores/context";
import { setArcLayer, setCountryLabelsLayer, setCountryMapLayer, setScatterplotLayer } from "lib/map";

let prevProductsCountry: any = null;
let prevSelectedProduct: any = null;
let productsCountryChanged = false;
let selectedProductChanged = false;
let activeArcs = "one";

const updateDeckLayers = (setLayers, viewState, postRender = false) => {
  const { activeCategory, hoveredPolygonIndex, year, selectedProduct, productsCountry } = mapData;

  if (productsCountry && productsCountry !== prevProductsCountry) {
    prevProductsCountry = productsCountry;
    productsCountryChanged = true;
  }
  if (selectedProduct && selectedProduct !== prevSelectedProduct) {
    prevSelectedProduct = selectedProduct;
    selectedProductChanged = true;
    if (activeArcs === "one") activeArcs = "two";
    else activeArcs = "one";
  }

  let shouldShowArcs = productsCountry !== null && selectedProduct !== null;

  const { activeCountry, activeView } = context;

  const layers = [setCountryMapLayer(activeCategory, hoveredPolygonIndex, activeCountry, activeView, year)];
  if (productsCountry && selectedProduct) {
    // console.group("UPDATE");
    // console.log("productsCountry: ", productsCountry);
    // console.log("selectedProduct: ", selectedProduct);
    // console.log("productsCountryChanged: ", productsCountryChanged);
    // console.log("selectedProductChanged: ", selectedProductChanged);
    // console.log("shouldShowArcs: ", shouldShowArcs);
    // console.log("activeArcs: ", activeArcs);
    // console.groupEnd();
    layers.push(setScatterplotLayer(productsCountry));
    // if (!postRender) {
    //   layers.push(setArcLayer(productsCountry, selectedProduct, mapData.year, activeArcs === "one" ? 0.0 : 0.0, "one"));
    //   layers.push(setArcLayer(productsCountry, selectedProduct, mapData.year, activeArcs === "two" ? 0.0 : 0.0, "two"));
    // } else {
    //   layers.push(setArcLayer(productsCountry, selectedProduct, mapData.year, activeArcs === "one" ? 1.0 : 0.0, "one"));
    //   layers.push(setArcLayer(productsCountry, selectedProduct, mapData.year, activeArcs === "two" ? 1.0 : 0.0, "two"));
    // }
    layers.push(setArcLayer(productsCountry, selectedProduct, mapData.year, 1, "product arcs"));
    layers.push(setCountryLabelsLayer(productsCountry, selectedProduct, viewState));
  }

  setLayers(layers);
};

export default updateDeckLayers;
